<template>
    <div class="h-100">
        <c-site-contract-flip-card
            :title    = "$t('contract.lim.title')"
            :contract = "contract"
            :unit     = "unit "
            :edit     = "true"
            @readonly = "onReadonly"
            @store    = "onStore"
        >
            <template v-slot:front>
                <f-title
                    v-if   = "isContract"
                    class  = "mt-3"
                    :title = "$t('contract.terms')"
                />

                <div v-if="isContract">
                    <v-row class="no-frame" v-if="contract.type.id === 1">
                        <v-col class="no-frame pr-2">
                            <f-read-only-field
                                class  = "w-100 ro-gap"
                                :label    = "$t('contract.lim.pricePerMonth')"
                                :value = "moneyAsString(contract.pricePerMonth)"
                                color  = "pt-0-5 pl-1 ro-background"
                            />
                        </v-col>
                        <v-col class="no-frame pl-2">
                            <f-read-only-field
                                class  = "w-100 ro-gap"
                                :label    = "$t('contract.lim.lgsPerMonth')"
                                :value = "moneyAsString(contract.lgsPerMonth)"
                                color  = "pt-0-5 pl-1 ro-background"
                            />
                        </v-col>
                    </v-row>

                    <v-row class="no-frame"  v-if="contract.type && contract.type.id === 2">
                        <c-contract-dls-amounts
                            :readonly = "readonly"
                            :contract = "contract"
                        />
                    </v-row>
                </div>

                <f-title
                    v-if   = "isContract"
                    :title = "$t('contract.billing')"
                    class  = "mt-4"
                />

                <div v-if="isContract && isLim">
                    <v-row class="no-frame"  >
                        <v-col class="no-frame">
                            <f-read-only-field
                                class  = "w-100 ro-gap"
                                :label = "$t('contract.lim.invoiceHandling')"
                                :value = "contract.invoiceHandling.name"
                                filled
                            />
                        </v-col>
                    </v-row>

                    <v-row class="no-frame">
                        <v-col class="no-frame pr-2">
                            <f-read-only-field
                                class  = "w-100 ro-gap"
                                :label = "$t('contract.lim.splitMaintenance')"
                                :value = "contract.splitMaintenance"
                                filled
                            />
                        </v-col>
                        <v-col class="no-frame p-2">
                            <f-read-only-field
                                class  = "w-100 ro-gap"
                                :label = "$t('contract.lim.splitRepair')"
                                :value = "contract.splitRepair"
                                filled
                            />
                        </v-col>
                    </v-row>
                </div>

                <f-title
                    v-if   = "isContract"
                    class  = "mt-2"
                    :title = "$t('contract.addresses')"
                />

                <v-row class="no-frame mb-4 pa-2 ro-background " v-if="isContract">
                    <div v-if="contract.benefitRecipient" class="w-100">
                        <f-read-only-field
                            class  = "w-100 ro-gap"
                            :label = "$t('contract.recipient.benefit')"
                            :value = "contract.benefitRecipient.name"
                            :dense = "true"
                            color  = "pt-0-5"
                        />

                        <div class="mt-0"></div>
                        <div style="font-size: 13px">
                            {{ contract.benefitRecipient.nameAdd }}
                        </div>
                        <div style="font-size: 13px">
                            {{ contract.benefitRecipient.street }} {{ contract.benefitRecipient.zip }}  {{ contract.benefitRecipient.city }}
                        </div>
                    </div>
                </v-row>

                <v-row class="no-frame ro-background pa-2" v-if="isContract">
                    <div v-if="contract.invoiceRecipient" class="w-100">
                        <f-read-only-field
                            class  = "w-100 ro-gap"
                            :label = "$t('contract.recipient.invoice')"
                            :value = "contract.invoiceRecipient.name"
                            :dense = "true"
                            color  = "pt-0-5"
                        />

                        <div class="mt-0"></div>
                        <div v-if="contract.invoiceRecipient.nameAdd" style="font-size: 13px">
                            {{ contract.invoiceRecipient.nameAdd }}
                        </div>
                        <div style="font-size: 13px">
                            {{ contract.invoiceRecipient.street }} {{ contract.invoiceRecipient.zip }}  {{ contract.invoiceRecipient.city }}
                        </div>
                    </div>
                </v-row>
            </template>
        </c-site-contract-flip-card>
    </div>
</template>

<script>

import CSiteContractFlipCard from "@/modules/msd/company/contract/components/controls/common/CSiteContractFlipCard.vue";
import SiteContractMixin from "@/modules/msd/company/contract/components/controls/common/SiteContractMixin";
import FTitle from "@/modules/core/components/utils/FTitle.vue";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField.vue";
import Contract from "@/modules/msd/company/contract/service/Contract";
import Core from "@/modules/core/service/Core";
import CContractDlsAmounts from "@/modules/msd/company/contract/components/controls/lim/CContractDlsAmounts.vue";

export default {
    name: "CSiteContractLim",

    mixins: [
        SiteContractMixin
    ],

    components: {
        CContractDlsAmounts,
        FReadOnlyField,
        FTitle,
        CSiteContractFlipCard,
    },

    props: {
        contract: {
            required: true,
            type    : Object,
            default : function () {
                return {
                    invoiceHandling: null,
                }
            }
        },

        unit: {

        }
    },

    data: () => ({
        percentRule: [
            (v)=> {
                if (v && (v <= 0 || v > 100)) {
                    return 'Zahl zwischen 1 und 100'
                }

                return true;
            }
        ]
    }),

    computed: {
        isLim () {
            if (!this.contract.type) {
                return false;
            }
            return this.contract.type.id === Contract.enums.types.lim;
        },

        isContract () {
            return this.contract && this.contract.id;
        }
    },

    methods: {
        onStore () {
            if (this.isLim) {
                Contract.unit.saveLim(this.unitId, this.contract.id,{
                    start: this.contract.unit.start,
                    end  : this.contract.unit.end,
                }).then(() => {
                    Core.message.hint(this, this.$t('contract.edit.stored'));
                })
            } else {
                Contract.unit.saveDls(this.unitId, this.contract.id,{
                    start      : this.contract.unit.start,
                    end        : this.contract.unit.end,
                    netamount  : this.contract.unit.netamount,
                    grossamount: this.contract.unit.grossamount,
                }).then(() => {
                    Core.message.hint(this, this.$t('contract.edit.stored'));
                })
            }
        },

        onChangeSplitMaintenance () {
            const value =this.contract.splitMaintenance;
            if (!value && value.length === 0) {
                this.contract.splitRepair = null;
                return;
            }

            const intValue = parseInt(value);
            if (intValue <= 0 || intValue > 100) {
                this.contract.splitRepair = null;
                return;
            }

            this.contract.splitRepair = 100 - this.contract.splitMaintenance;
        },

        onChangeSplitRepair () {
            const value =this.contract.splitRepair;
            if (!value && value.length === 0) {
                this.contract.splitMaintenance = null;
                return;
            }

            const intValue = parseInt(value);
            if (intValue <= 0 || intValue > 100) {
                this.contract.splitMaintenance = null;
                return;
            }

            this.contract.splitMaintenance = 100 - this.contract.splitRepair;
        },
    }
}
</script>

<style scoped>

.money ::v-deep input{
    text-align: right;
}

</style>
